/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import CookieConsent from './src/components/CookieConsent';

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <CookieConsent />
  </>
);
